
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Settings, MessageSquare } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import PersonaDropdown from "@/components/layout/PersonaDropdown";
import { MessageNotifications } from "@/components/messaging/MessageNotifications";
import { usePersonaContext } from "@/contexts/PersonaContext";

export const AppNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentPersona } = usePersonaContext();
  const isGSClientPortal = location.pathname === "/gs-client-portal";
  const isGSClientUser = currentPersona?.name === "GS Client User";
  
  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        throw error;
      }
      
      toast.success("You have been logged out");
      navigate("/login");
    } catch (error: any) {
      console.error("Logout error:", error);
      toast.error(error.message || "Logout failed");
    }
  };

  return (
    <header className="border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="/lovable-uploads/1268e013-62c0-4efc-98ef-21ea816431fb.png" 
            alt="Standardly Logo" 
            className="h-8 w-auto" 
          />
        </Link>
        
        <div className="flex items-center gap-4">
          <Link to={isGSClientPortal ? "/gs-client-portal" : "/dashboard"}>
            <Button 
              variant="ghost" 
              size="sm" 
              className={
                (isGSClientPortal && location.pathname === "/gs-client-portal") ||
                (!isGSClientPortal && location.pathname === "/dashboard")
                  ? "font-medium text-primary" 
                  : ""
              }
            >
              Dashboard
            </Button>
          </Link>
          {!isGSClientPortal && (
            <Link to="/standards">
              <Button 
                variant="ghost" 
                size="sm" 
                className={location.pathname === "/standards" ? "font-medium text-primary" : ""}
              >
                Standards
              </Button>
            </Link>
          )}
          {!isGSClientUser && (
            <Link to="/directory">
              <Button 
                variant="ghost" 
                size="sm" 
                className={location.pathname === "/directory" ? "font-medium text-primary" : ""}
              >
                Directory
              </Button>
            </Link>
          )}
          <Link to="/messages">
            <Button 
              variant="ghost" 
              size="sm" 
              className={location.pathname === "/messages" ? "font-medium text-primary" : ""}
            >
              <MessageSquare className="h-4 w-4 mr-2" />
              Messages
            </Button>
          </Link>
          <MessageNotifications 
            onMessageClick={() => navigate("/messages")}
          />
          <Link to="/settings">
            <Button 
              variant="ghost" 
              size="sm" 
              className={location.pathname === "/settings" ? "font-medium text-primary" : ""}
            >
              <Settings className="h-4 w-4 mr-2" />
              Settings
            </Button>
          </Link>
          <PersonaDropdown />
          <Button variant="ghost" size="sm" onClick={handleLogout}>
            <LogOut className="h-5 w-5 mr-2" />
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};
